// Environment-specific API URLs must come from the build environment. Keeping
// a production or QA fallback here can silently point a correctly deployed UI
// at the wrong backend.
const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const resolvedApiBaseUrl = configuredApiBaseUrl
  || (process.env.NODE_ENV === 'test' ? 'http://localhost/api/customer-app' : '');

if (!resolvedApiBaseUrl) {
  throw new Error('REACT_APP_API_BASE_URL is required to run the storefront.');
}

export const API_BASE_URL = resolvedApiBaseUrl.replace(/\/+$/, '');

export const TOKEN_STORAGE_KEYS = {
  access: 'fnh_access_token',
  refresh: 'fnh_refresh_token',
};

export const RAZORPAY_CHECKOUT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';
